(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3725,5637,1868,682,1803],{

/***/ 861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; }
/* harmony export */ });
/* unused harmony export isTrivialHref */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
const _excluded = ["as", "disabled"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }


function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }
  const meta = {
    tagName
  };
  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }
  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');
    if (disabled) {
      href = undefined;
    }
  }
  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
      as: asProp,
      disabled
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["ZP"] = (Button);

/***/ }),

/***/ 1868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4012);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2965);
/* harmony import */ var _CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var src_helpers_imageHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38);
/* harmony import */ var _public_logo_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3476);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4215);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1555);
/* harmony import */ var _assets_images_second_bg_png__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5893);










var AccordionComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return __webpack_require__.e(/* import() */ 4113).then(__webpack_require__.bind(__webpack_require__, 4113));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4113)];
    }
  }
});




var CommonQuestions = function CommonQuestions(_ref) {
  var commonQuestionsBackgroundImage = _ref.commonQuestionsBackgroundImage,
      filteredQuestions = _ref.filteredQuestions;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(),
      locale = _useRouter.locale;

  var isRtl = locale === "ar";
  var dir = isRtl ? "rtl" : "ltr";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("section", {
    className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().questions),
    style: {
      backgroundImage: "url(".concat(_assets_images_second_bg_png__WEBPACK_IMPORTED_MODULE_7__/* ["default"].src */ .Z.src, ")")
    },
    dir: dir,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__["default"], {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h2", {
        className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().customHead),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          id: "popular-questions"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["common-questions"]),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__["default"], {
          className: "gy-4",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__["default"], {
            xs: 12,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_CommonQuestions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().accordion),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(AccordionComponent, {
                data: filteredQuestions
              })
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CommonQuestions);

/***/ }),

/***/ 38:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f8": function() { return /* binding */ buildApiUrl; }
/* harmony export */ });
/* unused harmony exports getImageUrl, validateImageUrl, getImageDimensions */
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);


var buildApiUrl = function buildApiUrl(path) {
  if (!path) return "";

  try {
    new URL(path);
    return path;
  } catch (_unused) {
    var base = "https://mu7.ejjadh.info" || 0;
    var sep = path.startsWith("/") ? "" : "/";
    return "".concat(base).concat(sep).concat(path);
  }
}; // Helper function to ensure valid image URLs and proper error handling

var getImageUrl = function getImageUrl(path) {
  if (!path) return null;

  try {
    // If it's already a full URL, return it
    new URL(path);
    return path;
  } catch (_unused2) {
    // If it's a relative path, prepend the API URL
    return buildApiUrl(path);
  }
}; // Helper function to validate image

var validateImageUrl = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, {
              method: "HEAD"
            });

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.ok);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", false);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function validateImageUrl(_x) {
    return _ref.apply(this, arguments);
  };
}())); // Helper function to get proper image dimensions

var getImageDimensions = function getImageDimensions() {
  var imageType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var dimensions = {
    "default": {
      width: 800,
      height: 600
    },
    thumbnail: {
      width: 150,
      height: 150
    },
    banner: {
      width: 1920,
      height: 1080
    },
    profile: {
      width: 300,
      height: 300
    }
  };
  return dimensions[imageType] || dimensions["default"];
};

/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ services_Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./src/modules/services/servicesSection/styles/styles.module.scss
var styles_module = __webpack_require__(3376);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/modules/services/servicesSection/ServiceCard.jsx










var BlogCard = function BlogCard(_ref) {
  var _titleStyle;

  var service = _ref.service,
      index = _ref.index;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var image = service.image,
      title = service.title,
      price = service.price,
      slug = service.slug;

  var _useState = (0,react.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var blockStyle = {
    marginBottom: "25px",
    textAlign: "center",
    boxShadow: "0 0 10px #0000001a",
    borderRadius: "10px",
    height: "calc(100% - 25px)",
    transition: "0.3s",
    transform: isHovered ? "translateY(-10px)" : "translateY(0)"
  };
  var blockImgStyle = {
    borderRadius: "10px 10px 0 0",
    position: "relative",
    overflow: "hidden",
    height: "140px",
    margin: "0 auto",
    backgroundColor: "#f7f7f7",
    border: "1px solid #dfdfdf"
  };
  var imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "0.3s",
    transform: isHovered ? "scale(1.1)" : "scale(1)"
  };
  var linkStyle = {
    position: "absolute",
    inset: "0",
    zIndex: "1"
  };
  var contentStyle = {
    padding: "20px"
  };
  var titleStyle = (_titleStyle = {
    fontSize: "18px",
    display: "inline-block",
    fontWeight: "700",
    color: isHovered ? "#e72229" : "black"
  }, (0,defineProperty/* default */.Z)(_titleStyle, "display", "-webkit-box"), (0,defineProperty/* default */.Z)(_titleStyle, "WebkitLineClamp", "2"), (0,defineProperty/* default */.Z)(_titleStyle, "lineClamp", "2"), (0,defineProperty/* default */.Z)(_titleStyle, "WebkitBoxOrient", "vertical"), (0,defineProperty/* default */.Z)(_titleStyle, "overflow", "hidden"), (0,defineProperty/* default */.Z)(_titleStyle, "transition", "0.3s"), _titleStyle);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Col["default"], {
    xs: 6,
    sm: 6,
    md: 4,
    lg: 3,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: blockStyle,
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHovered(false);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        style: blockImgStyle,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/services/".concat(slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: linkStyle
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "".concat("https://mu7.ejjadh.info", "/").concat(image),
          alt: "service-img",
          width: 1920,
          height: 1080,
          loading: "lazy",
          quality: 100,
          style: imgStyle
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: contentStyle,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/services/".concat(slug),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: titleStyle,
            children: (title === null || title === void 0 ? void 0 : title[locale].length) > 50 ? (title === null || title === void 0 ? void 0 : title[locale].slice(0, 50)) + "..." : title === null || title === void 0 ? void 0 : title[locale].slice(0, 50)
          })
        })
      })]
    })
  });
};

/* harmony default export */ var ServiceCard = (BlogCard);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4215);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(5005);
;// CONCATENATED MODULE: ./src/modules/services/servicesSection/Index.jsx








var Index = function Index(_ref) {
  var _servicesData$service2;

  var data = _ref.data;
  var servicesData = data.servicesData;

  var _useState = (0,react.useState)(8),
      visibleServices = _useState[0],
      setVisibleServices = _useState[1];

  var renderServices = function renderServices() {
    var _servicesData$service;

    if ((servicesData === null || servicesData === void 0 ? void 0 : (_servicesData$service = servicesData.services) === null || _servicesData$service === void 0 ? void 0 : _servicesData$service.length) > 0) {
      return servicesData === null || servicesData === void 0 ? void 0 : servicesData.services.slice(0, visibleServices).map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceCard, {
          service: item,
          index: index
        }, index);
      });
    }

    return null;
  };

  var showMoreServices = function showMoreServices() {
    setVisibleServices(function (prev) {
      return prev + 8;
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (styles_module_default()).blogs,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container["default"], {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Row["default"], {
        children: renderServices()
      }), visibleServices < (servicesData === null || servicesData === void 0 ? void 0 : (_servicesData$service2 = servicesData.services) === null || _servicesData$service2 === void 0 ? void 0 : _servicesData$service2.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "view-all",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          className: "nav-link",
          onClick: showMoreServices,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "show-more"
          })
        })
      })]
    })
  });
};

/* harmony default export */ var servicesSection_Index = (Index);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/CommonQuestions/CommonQuestions.jsx
var CommonQuestions = __webpack_require__(1868);
;// CONCATENATED MODULE: ./src/modules/services/Index.jsx







var BreadCrumb = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 648).then(__webpack_require__.bind(__webpack_require__, 4346));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4346)];
    }
  }
});
var PageHeader = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(9477), __webpack_require__.e(4208), __webpack_require__.e(4823)]).then(__webpack_require__.bind(__webpack_require__, 2094));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2094)];
    }
  }
});
var Footer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(646), __webpack_require__.e(7148), __webpack_require__.e(6892)]).then(__webpack_require__.bind(__webpack_require__, 7148));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7148)];
    }
  }
});

var Index_Index = function Index(_ref) {
  var _data$questions, _data$questions$, _data$questions$$cate, _data$questions$$cate2, _targetQuestion$data;

  var data = _ref.data;
  var questionsData = data === null || data === void 0 ? void 0 : (_data$questions = data.questions) === null || _data$questions === void 0 ? void 0 : (_data$questions$ = _data$questions[0]) === null || _data$questions$ === void 0 ? void 0 : (_data$questions$$cate = _data$questions$.categories) === null || _data$questions$$cate === void 0 ? void 0 : (_data$questions$$cate2 = _data$questions$$cate[0]) === null || _data$questions$$cate2 === void 0 ? void 0 : _data$questions$$cate2.posts;
  var targetQuestion = questionsData === null || questionsData === void 0 ? void 0 : questionsData.find(function (question) {
    return question.id === 417;
  });
  var commonQuestionsBackgroundImage = targetQuestion === null || targetQuestion === void 0 ? void 0 : (_targetQuestion$data = targetQuestion.data) === null || _targetQuestion$data === void 0 ? void 0 : _targetQuestion$data.image;
  var filteredQuestions = questionsData === null || questionsData === void 0 ? void 0 : questionsData.filter(function (question) {
    return question.id !== 417;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PageHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb, {
      title: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "services"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(servicesSection_Index, {
      data: data
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CommonQuestions["default"], {
      commonQuestionsBackgroundImage: commonQuestionsBackgroundImage,
      filteredQuestions: filteredQuestions
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer, {})]
  });
};

/* harmony default export */ var services_Index = (Index_Index);

/***/ }),

/***/ 3476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.72f176e4.png","height":3264,"width":5016,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAANlBMVEUBAAALAAD3AAALDhALGCAFCw4OGSABAAAOFx4AAADdAQIPFx6xBQjxAAAOGSIRFSIAFxcAGyS2XswHAAAAEnRSTlM7K1sySyGvJ4E4fVJZJp08C3gWJ2qoAAAACXBIWXMAAEzlAABM5QF1zvCVAAAALElEQVR4nAXBhwEAEBAAscNX3f7LSogRcUevbDNrb3ZEj4TUhTdX96IkCUn5HKQBEo69UrAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/second-bg.d53eab00.png","height":523,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEXe3t7k5OTi4uLo6Oji4uKEqJd8AAAABXRSTlM5Y1NwR+60uYcAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAXSURBVHicY2BgYmBiACFmRmZGRkYmZgAAqAAWu9UqAAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 2965:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"questions":"CommonQuestions_questions__ilkFQ","customHead":"CommonQuestions_customHead__cjF8U","common-questions":"CommonQuestions_common-questions__5obFp","background-image":"CommonQuestions_background-image__fAeTz","overlay-text":"CommonQuestions_overlay-text___OSqI","cta-button-red":"CommonQuestions_cta-button-red__wtYiF","icon-circle":"CommonQuestions_icon-circle__9e8xI","accordion":"CommonQuestions_accordion__1qFeG","BlueHoleIcon":"CommonQuestions_BlueHoleIcon___wAeX"};

/***/ }),

/***/ 3376:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blogs":"styles_blogs__GIMrs"};

/***/ }),

/***/ 5005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(861);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";






const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  as,
  bsPrefix,
  variant = 'primary',
  size,
  active = false,
  disabled = false,
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0,_restart_ui_Button__WEBPACK_IMPORTED_MODULE_4__/* .useButtonProps */ .FT)({
    tagName: as,
    disabled,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...buttonProps,
    ...props,
    ref: ref,
    disabled: disabled,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
  });
});
Button.displayName = 'Button';
/* harmony default export */ __webpack_exports__["Z"] = (Button);

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCol": function() { return /* binding */ useCol; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["default"] = (Col);

/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  fluid = false,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  className,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'container');
  const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, fluid ? `${prefix}${suffix}` : prefix)
  });
});
Container.displayName = 'Container';
/* harmony default export */ __webpack_exports__["default"] = (Container);

/***/ }),

/***/ 4215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["default"] = (Row);

/***/ }),

/***/ 4012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _useIntl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */




function areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(prevProps, ["values"]);
    var nextValues = nextProps.values, nextOtherProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(nextProps, ["values"]);
    return ((0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(nextValues, values) &&
        (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .shallowEqual */ .wU)(otherProps, nextOtherProps));
}
function FormattedMessage(props) {
    var intl = (0,_useIntl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? react__WEBPACK_IMPORTED_MODULE_0__.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag,
    });
    if (typeof children === 'function') {
        return children(Array.isArray(nodes) ? nodes : [nodes]);
    }
    if (Component) {
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(nodes));
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, nodes);
}
FormattedMessage.displayName = 'FormattedMessage';
var MemoizedFormattedMessage = react__WEBPACK_IMPORTED_MODULE_0__.memo(FormattedMessage, areEqual);
MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
/* harmony default export */ __webpack_exports__["Z"] = (MemoizedFormattedMessage);


/***/ }),

/***/ 6896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIntl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _injectIntl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(680);



function useIntl() {
    var intl = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_injectIntl__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._y);
    (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .invariantIntlContext */ .lq)(intl);
    return intl;
}


/***/ })

}]);